/* eslint-disable @typescript-eslint/no-require-imports */
if (process.env.NODE_ENV === 'development') {
  import('react-grab')
}

if (process.env.NODE_ENV === 'production') {
  require('core-js/stable')
  require('regenerator-runtime/runtime')
}

import { createRoot } from 'react-dom/client'

import AppProvider from './AppProvider'
import { initSentryFn } from './utils/sentryUtils'

// Init sentry
initSentryFn()

const container = document.getElementById('root')!
const root = createRoot(container)

const renderApp = () => root.render(<AppProvider />)

if (module.hot) {
  module.hot.accept('./App', renderApp)
}

renderApp()
